import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { FUNC_DEFAULT, OBJECT_DEFAULT } from 'constants';
import usePortalModal from 'hooks/usePortalModal';

const usePayto = () => {
  const { showPortalModalName } = usePortalModal();

  const onShowAddPaytoAccountModal = (modalOptions) => {
    showPortalModalName({
      name: PORTAL_NAME_MODAL_DEFINE.ADD_PAYTO_ACCOUNT_MODAL,
      modalOptions,
    });
  };

  const onShowEditPaytoAccountAgreementModal = ({
    modalData = OBJECT_DEFAULT,
    modalOptions = OBJECT_DEFAULT,
    action = FUNC_DEFAULT,
    actionClose = FUNC_DEFAULT,
  }) => {
    showPortalModalName({
      name: PORTAL_NAME_MODAL_DEFINE.EDIT_PAYTO_ACCOUNT_AGREEMENT_MODAL,
      modalData,
      modalOptions,
      action,
      actionClose,
    });
  };

  const onShowDeletePaytoAccountAgreementModal = ({
    action = FUNC_DEFAULT,
    actionClose = FUNC_DEFAULT,
  }) => {
    showPortalModalName({
      name: PORTAL_NAME_MODAL_DEFINE.DELETE_PAYTO_ACCOUNT_AGREEMENT_MODAL,
      action,
      actionClose,
    });
  };

  return {
    onShowAddPaytoAccountModal,
    onShowEditPaytoAccountAgreementModal,
    onShowDeletePaytoAccountAgreementModal,
  };
};

export default usePayto;
